class Config{
    constructor(){
        this.freeMembership = false;
    }

    //Retrieves free membership status
    downloadFreeMembershipConfig(cb){
        var that = this;
        fetch(localStorage.getItem('server') + 'config', {
            method:'GET'
        })
        .then((resp)=>{
            return resp.json();
        })
        .then((data)=>{
            if(data.membershipConfig === 'true'){
                that.freeMembership = true;
            }
            cb(that.freeMembership);
        });
    }

    //Returns freeMembership status
    getFreeMembershipConfig(){
        return this.freeMembership;
    }
}

export default new Config();